import { useEffect, useState } from "react";
import axios from "axios";
import ProductCard from "@/components/ProductCard";
import QuickViewModal from "@/components/QuickViewModal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CATEGORIES = ["All", "Recovery", "Sleep", "Mobility", "Wellness"];

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("All");
  const [quickView, setQuickView] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then(({ data }) => setProducts(data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = category === "All" ? products : products.filter((p) => p.category === category);

  return (
    <section id="shop" data-testid="product-grid-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <p className="text-xs tracking-[0.4em] uppercase text-gold mb-4">The Collection</p>
            <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl text-charcoal">
              Tools for deeper recovery
            </h2>
          </div>
          <div data-testid="category-filters" className="flex flex-wrap gap-3">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase()}`}
                onClick={() => setCategory(c)}
                className={`px-5 py-2 text-xs tracking-[0.2em] uppercase rounded-full border transition-colors duration-300 ${
                  category === c
                    ? "bg-gold border-gold text-charcoal font-semibold"
                    : "border-taupe/50 text-charcoal/60 hover:border-gold hover:text-charcoal"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-square bg-taupe/20 rounded-sm" />
                <div className="h-4 bg-taupe/20 rounded mt-5 w-2/3" />
                <div className="h-3 bg-taupe/20 rounded mt-2 w-1/2" />
              </div>
            ))}
          </div>
        ) : (
          <div data-testid="product-grid" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            {filtered.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} onQuickView={setQuickView} />
            ))}
          </div>
        )}
      </div>

      <QuickViewModal product={quickView} onClose={() => setQuickView(null)} />
    </section>
  );
};

export default ProductGrid;
